import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import PDFViewer from 'modules/_shared/components/PDFViewer';

type EmbedPDFViewerProps = {
  fileUrl: string | null;
};

const EmbedPDFViewer: FC<EmbedPDFViewerProps> = ({ fileUrl }) => {
  const { t } = useTranslate();

  return (
    <div
      className="border rounded p-0 overflow-hidden"
      style={{ height: '300px', overflow: 'auto', backgroundColor: '#f8f9fa' }}
    >
      {fileUrl ? (
        <PDFViewer file={fileUrl} width={400} height={300} />
      ) : (
        <div
          className="d-flex align-items-center justify-content-center h-100"
          style={{ color: '#6c757d' }}
        >
          <div className="text-center">
            <em className="icon ni ni-file-pdf" style={{ fontSize: '3rem' }} />
            <p className="mt-2 mb-0">{t('EmbedPDFViewerNoFileSelected')}</p>
            <small>{t('EmbedPDFViewerUploadPDFToPreview')}</small>
          </div>
        </div>
      )}
    </div>
  );
};

export default EmbedPDFViewer;
